module.exports = __webpack_public_path__ + "img/golf.29a81f83.svg";